import React from "react";
import { NavLink } from "react-router-dom";
import styles from "@/styles/AdminNav.module.css";
import { css } from "@emotion/css";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import NavItem from 'react-bootstrap/NavItem';

const navDynamic = css`
  position: relative; /* required for ::after */

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }

  /* show white background (aria-current="page") */

  &:hover::after,
  &[aria-current="page"]::after {
    content: "";
    color: #F16D09;
    position: absolute;
    top: 0;
    left: 0;
    width: 110%;
    height: 100%;
    background: white;
    border-top-right-radius: 0 px;
    border-bottom-right-radius: 0 px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    z-index: -1;
  }

  /* active state via NavLink aria-current attribute */
  &[aria-current="page"] {
    background: var(--link-bg-active);
    color: #F16D09;
  }
`;

export default function SideNav() {
  const combo = (base) => `${base} ${navDynamic}`.trim();

  return (
    <div className={styles.layout}>
      <nav className={styles.sideNav}>
        <ul className={styles.navList}>
          <li className={styles.navItem}>
            {/* exact match for admin home */}
            <NavLink
              to="/admin"
              end
              className={({ isActive }) =>
                `${combo(styles.navLink)} ${isActive ? styles.navLinkActive : ""}`.trim()
              }
            >
              Admin Home and User Tools
            </NavLink>
          </li>

          <li className={styles.navItem}>
            <NavLink
              to="/admin/surveyManager"
              className={({ isActive }) =>
                `${combo(styles.navLink)} ${isActive ? styles.navLinkActive : ""}`.trim()
              }
            >
              Survey Tools
            </NavLink>
          </li>

          <li className={styles.navItem}>
            <NavLink
              to="/admin/reportsManager"
              className={({ isActive }) =>
                `${combo(styles.navLink)} ${isActive ? styles.navLinkActive : ""}`.trim()
              }
            >
              Report Tools
            </NavLink>
          </li>

          <li className={styles.navItem}>
            <NavLink
              to="/admin/configManager"
              className={({ isActive }) =>
                `${combo(styles.navLink)} ${isActive ? styles.navLinkActive : ""}`.trim()
              }
            >
              Platform Configuration
            </NavLink>
          </li>

        </ul>
      </nav>
    </div>
  );
}